module.exports = __webpack_public_path__ + "static/media/head.96f82d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/types/head.png
// module id = 73
// module chunks = 0